import {
    SET_PPA_RATE,
    SET_PPA_TERM,
    SET_PPA_ESCALATOR,
    SET_SHOW_PPA,
    SET_PPA,
} from './constants';

export const setPPA = ppa => ({
    type: SET_PPA,
    ppa,
});
export const setPPARate = rate => ({
    type: SET_PPA_RATE,
    rate,
});

export const setPPATerm = term => ({
    type: SET_PPA_TERM,
    term,
});

export const setPPAEscalator = escalator => ({
    type: SET_PPA_ESCALATOR,
    escalator,
});

export const setShowPPA = showPPA => ({
    type: SET_SHOW_PPA,
    showPPA,
});



// WEBPACK FOOTER //
// ./src/containers/common/ppa/actions.js